import React from 'react';
import {Upload, Icon} from 'antd';
import download from '../../util/fileDownload';

class Logo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fileList: []
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.logo) {
            const {id: uid, file: {original_file_name: name, status = 'done'}} = nextProps.logo;
            const fileList = [{
                uid,
                name,
                status,
                url: `/api/documents/${uid}`
            }];
            return {fileList}
        }
        return null;
    }
    handleChange(info) {
        this.setState({
            loading: info.file.status === 'uploading',
            fileList: [...info.fileList]
        });
    }
    render() {
        const {logo, onUpload, onRemove} = this.props;
        const {fileList} = this.state;

        const onPreview = (file) => {
            const {url, name} = file;
            return download(url, name);
        };

        return (
            <Upload
                name="document"
                className="gc-uploader"
                data={{doc_type: 'Business Logo'}}
                customRequest={onUpload}
                onChange={this.handleChange.bind(this)}
                onPreview={onPreview}
                onRemove={onRemove}
                fileList={fileList}
                style={{ width: '100%' }}
            >
                {!fileList.length ? (
                    <div>
                        <Icon type={this.state.loading ? 'loading' : 'plus'} />
                        <div className="ant-upload-text">Upload Business Logo</div>
                    </div>
                ) : null}
            </Upload>
        )
    }
};

export default Logo;


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/Logo.js